.iconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  transition: var(--transition-button);
  flex-shrink: 0;
  box-sizing: border-box;
}

.large {
  width: var(--size-input-height-lg);
  height: var(--size-input-height-lg);
  border-radius: var(--radius-2xl);
}

.medium {
  width: var(--size-input-height-md);
  height: var(--size-input-height-md);
  border-radius: var(--radius-xl);
}

.small {
  width: var(--size-input-height-sm);
  height: var(--size-input-height-sm);
  border-radius: var(--radius-lg);
}

.xsmall {
  width: var(--size-input-height-xs);
  height: var(--size-input-height-xs);
  border-radius: var(--radius-md);
}

.primary {
  background-color: var(--surface-action-primary-default);
  color: var(--content-on-action-primary);
  border: var(--border-width-action-primary) solid var(--border-action-primary-default);
  box-shadow: var(--shadow-action-primary-offset-x-default) var(--shadow-action-primary-offset-y-default) 0 0
    var(--shadow-action-primary-default);
}

.primary:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: var(--surface-action-primary-hover);
  border-color: var(--border-action-primary-hover);
  box-shadow: var(--shadow-action-primary-offset-x-hover) var(--shadow-action-primary-offset-y-hover) 0 0
    var(--shadow-action-primary-hover);
  transform: var(--transform-button-hover);
}

.primary:active {
  background-color: var(--surface-action-primary-active);
  border-color: var(--border-action-primary-active);
  box-shadow: 0 0 0 0 var(--shadow-action-primary-active);
  transform: var(--transform-button-active);
}

/* Legacy mode: restore master's circular icon buttons with hardcoded sizes.
   Master used border-radius: 50% and fixed px values. */
/* stylelint-disable-next-line @classdojo/no-top-level-elements-in-modules */
[data-dds-tokens="legacy"] .large {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

/* stylelint-disable-next-line @classdojo/no-top-level-elements-in-modules */
[data-dds-tokens="legacy"] .medium {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

/* stylelint-disable-next-line @classdojo/no-top-level-elements-in-modules */
[data-dds-tokens="legacy"] .small {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}

/* stylelint-disable-next-line @classdojo/no-top-level-elements-in-modules */
[data-dds-tokens="legacy"] .xsmall {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.iconButton:focus-visible {
  outline-offset: var(--spacing-xs);
  outline: var(--content-accent) var(--spacing-xs) solid;
}

.primarySubtle {
  background-color: var(--surface-action-primary-subtle-default);
  color: var(--content-on-action-primary-subtle);
  border: var(--border-width-action-primary-subtle) solid var(--border-action-primary-subtle-default);
  box-shadow: var(--shadow-action-primary-offset-x-default) var(--shadow-action-primary-offset-y-default) 0 0
    var(--shadow-action-primary-subtle-default);
}

.primarySubtle:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: var(--surface-action-primary-subtle-hover);
  border-color: var(--border-action-primary-subtle-hover);
  box-shadow: var(--shadow-action-primary-offset-x-hover) var(--shadow-action-primary-offset-y-hover) 0 0
    var(--shadow-action-primary-subtle-hover);
  transform: var(--transform-button-hover);
}

.primarySubtle:active {
  background-color: var(--surface-action-primary-subtle-active);
  border-color: var(--border-action-primary-subtle-active);
  box-shadow: 0 0 0 0 var(--shadow-action-primary-subtle-active);
  transform: var(--transform-button-active);
}

.secondary {
  background-color: var(--surface-action-secondary-default);
  color: var(--content-on-action-secondary);
  border: var(--border-width-action-secondary) solid var(--border-action-secondary-default);
  box-shadow: var(--shadow-action-secondary-offset-x-default) var(--shadow-action-secondary-offset-y-default) 0 0
    var(--shadow-action-secondary-default);
}

.secondary:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: var(--surface-action-secondary-hover);
  border-color: var(--border-action-secondary-hover);
  box-shadow: var(--shadow-action-secondary-offset-x-hover) var(--shadow-action-secondary-offset-y-hover) 0 0
    var(--shadow-action-secondary-hover);
  transform: var(--transform-button-hover);
}

.secondary:active {
  background-color: var(--surface-action-secondary-active);
  border-color: var(--border-action-secondary-active);
  box-shadow: 0 0 0 0 var(--shadow-action-secondary-active);
  transform: var(--transform-button-active);
}

.destructive {
  background-color: var(--surface-action-destructive-default);
  color: var(--content-on-action-destructive);
  border: var(--border-width-action-destructive) solid var(--border-action-destructive-default);
  box-shadow: var(--shadow-action-destructive-offset-x-default) var(--shadow-action-destructive-offset-y-default) 0 0
    var(--shadow-action-destructive-default);
}

.destructive:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: var(--surface-action-destructive-hover);
  border-color: var(--border-action-destructive-hover);
  box-shadow: var(--shadow-action-destructive-offset-x-hover) var(--shadow-action-destructive-offset-y-hover) 0 0
    var(--shadow-action-destructive-hover);
  transform: var(--transform-button-hover);
}

.destructive:active {
  background-color: var(--surface-action-destructive-active);
  border-color: var(--border-action-destructive-active);
  box-shadow: 0 0 0 0 var(--shadow-action-destructive-active);
  transform: var(--transform-button-active);
}

.destructiveTertiary {
  background-color: transparent;
  color: var(--content-on-action-destructive-tertiary);
}

.destructiveTertiary:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: var(--surface-action-destructive-tertiary-hover);
}

.destructiveTertiary:active {
  background-color: var(--surface-action-destructive-tertiary-active);
  transform: var(--transform-button-press);
}

.destructiveTertiary.disabled,
.destructiveTertiary.disabled:is(
    :hover,
    [data-state="open"],
    [data-state="delayed-open"],
    [data-state="instant-open"]
  ) {
  background-color: transparent;
  color: var(--content-on-action-disabled);
}

.tertiary {
  background-color: transparent;
  color: var(--content-accent);
}

.tertiary:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: var(--surface-action-tertiary-hover);
}

.tertiary:active {
  background-color: var(--surface-action-tertiary-active);
  transform: var(--transform-button-press);
}

.tertiary.disabled,
.tertiary.disabled:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: transparent;
  color: var(--content-on-action-disabled);
}

.gray {
  background-color: var(--surface-action-quiet-default);
  color: var(--content-primary);
}

.gray:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: var(--surface-action-quiet-hover);
  color: var(--content-primary);
}

.gray:active {
  background-color: var(--surface-action-quiet-active);
  color: var(--content-primary);
  transform: var(--transform-button-press);
}

.transparent {
  background-color: transparent;
  color: var(--content-primary);
}

.transparent:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: var(--surface-action-tertiary-hover);
}

.transparent:active {
  background-color: var(--surface-action-tertiary-active);
  transform: var(--transform-button-press);
}

.transparent.disabled,
.transparent.disabled:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: transparent;
  color: var(--content-on-action-disabled);
}

.media {
  background-color: var(--surface-media);
  color: var(--content-on-media);
  backdrop-filter: blur(16px);
}

.media:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: var(--surface-action-media-hover);
}

.media:active {
  background-color: var(--surface-action-media-active);
  transform: var(--transform-button-press);
}

.white {
  background-color: var(--surface-default);
  color: var(--content-primary);
}

.white:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: var(--surface-muted);
}

.white:active {
  background-color: var(--surface-action-secondary-active);
  transform: var(--transform-button-press);
}

.white.disabled,
.white.disabled:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  background-color: transparent;
  color: var(--content-on-action-disabled);
}

.disabled,
.disabled:is(:hover, [data-state="open"], [data-state="delayed-open"], [data-state="instant-open"]) {
  cursor: not-allowed;
  background-color: var(--surface-action-disabled);
  color: var(--content-on-action-disabled);
  border-color: transparent;
  box-shadow: none;
}

.icon {
  flex-shrink: 0;
}
